<template>
  <div class="loadingIcon">
    <img :src="loadingImage" :alt="altText" />
  </div>
</template>

<script setup>
import loadingImage from "../../images/loading-image.gif";
const props = defineProps({
  altText: {
    type: String,
    default: "Loading",
  },
});
</script>

<style scoped>
.loadingIcon {
  position: absolute;
  z-index: 99999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.35);
}
</style>
